import React from "react";
import cssClasses from "./EditButton.module.css";
import editImage from "../../../assets/images/edit-button.png";

const editButton = (props) => (
    <img className={cssClasses.EditButton} src={editImage} onClick={props.clicked} alt="edit"></img>
);

export default editButton;